const verificationCode = {
    /**
     * 載入 API-VerificationCode 的資料
     * 
     * @public
     */
    load(verification) {

        verification.code = null;
        verification.key = null;
        verification.image = null;

        axios.post(apiUrl.VerificationCode)
            .then(res => {
                verification.image = res.data.Data.Img;
                verification.key = res.data.Data.Key;
                
            });
    },
};
export default verificationCode;
